import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderSection  {
    _originalTypeClassName = "ekylikeio.BO.OrderSection";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderSection.translate = translateService;
}
this.Items = [];
this.Id = null;
this.TotalPrice = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TotalPrice:any;
Student:any;
Items:any;
OrderDateSection:any;
static setStudent = ($this, value) => {
var oldValue = $this.Student;
$this.Student = value;
if (value != null) {
}
}
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.OrderSection.removeItems($this, $this.Items[0]);
                }

                Domain.OrderSection.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderSection.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
if (item.OrderSection != $this) {
Domain.OrderItem.setOrderSection(item, $this);
}
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderSection.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
item.OrderSection = null;
}
static clearItems = ($this) => { $this.Items = null; }
static setOrderDateSection = ($this, value) => {
var oldValue = $this.OrderDateSection;
$this.OrderDateSection = value;
if (value != null) {
if (oldValue != null) {
Domain.OrderDateSection.removeStudentSections(oldValue, $this);
}
Domain.OrderDateSection.addStudentSections(value, $this);
}
}

static UpdatePrice($this: any): any{for (let _iitem = 0; _iitem < ($this?.Items == null ? 0 : $this?.Items.length); _iitem++) {let item = $this?.Items[_iitem];Domain.OrderItem.UpdatePrice(item);}
$this.TotalPrice = (CLMS.Framework.Number.Equal(() => $this.Items.length, () => 0) ? 0 : $this?.Items?.linq?.sum((i) => i?.TotalPrice));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}